import classNames from "classnames"
import React from "react"
import { AlgoliaStaticSearchResult } from "../controller/state/types"
import {
  filterPageIndexes,
  getAllPagesIndexes,
  isFirstPage,
  isLastPage,
} from "../utils/paging"
import classes from "./StaticSearchPagination.module.css"

interface Props {
  staticSearch: AlgoliaStaticSearchResult
}

const StaticSearchPagination = ({ staticSearch }: Props) => {
  const searchResults = staticSearch?.response?.results?.[0]
  if (!searchResults || searchResults.nbPages <= 1) {
    return <></>
  }

  const currentPage = searchResults.page ? searchResults.page + 1 : 1
  return (
    <ul className="flex items-center justify-center">
      {isFirstPage(currentPage) ? (
        <li className={classNames(classes.link, classes.linkDisabled)}>
          <span>←</span>
        </li>
      ) : (
        <li className={classes.link}>
          <a href="?page=1">←</a>
        </li>
      )}
      {filterPageIndexes(
        getAllPagesIndexes(searchResults.nbPages),
        currentPage
      ).map((page) => {
        return (
          <li
            key={page}
            className={classNames(classes.link, {
              [classes.linkActive]: currentPage === page,
            })}
          >
            <a href={`?page=${page}`}>{page}</a>
          </li>
        )
      })}

      {isLastPage(currentPage, searchResults.nbPages) ? (
        <li className={classNames(classes.link, classes.linkDisabled)}>
          <span>→</span>
        </li>
      ) : (
        <li className={classes.link}>
          <a href={`?page=${currentPage + 2}`}>→</a>
        </li>
      )}
    </ul>
  )
}

export default StaticSearchPagination
